enum GamReportType {
  Total = 'TOTAL',
  Date = 'DATE',
  Device = 'DEVICE',
  Region = 'REGION',
  Channel = 'CHANNEL',
  Advertiser = 'ADVERTISER',
  Campaign = 'CAMPAIGN',
  Placement = 'PLACEMENT',
  Creative = 'CREATIVE',
  Publisher = 'PUBLISHER',
  Daypart = 'DAYPART',
  DayOfWeek = 'DAY_OF_WEEK',
  Deals = 'DEALS',
  GeoFence = 'GEO_FENCE',
  // GeoMap scale-switcher breakdowns. Each scale has its own GAM ReportJob
  // keyed on the matching dim (METRO_NAME / COUNTY_NAME / CITY_NAME /
  // POSTAL_CODE).
  Dma = 'DMA',
  County = 'COUNTY',
  City = 'CITY',
  Zip = 'ZIP',
  // No native GAM dim — backend derives both from the Zip snapshot.
  CongressionalDistrict = 'CONGRESSIONAL_DISTRICT',
}

export default GamReportType;
